<template>

        <el-card class="box-card">
            <el-row>

                <el-select  v-if="isShow"  v-model.number="selectedUsedCarConfigId" filterable placeholder="请选择价格配置源">
                    <el-option
                            v-for="item in options"
                            :key="item.usedCarConfigId"
                            :label="item.userdCarConfigName"
                            :value="item.usedCarConfigId">
                    </el-option>
                </el-select>
            </el-row>
                <el-row>
                    <el-form  :inline="true" ref="privateUsedCarConfigForm" label-position="left"   :rules="rules" :model="usedCarConfigForm" size="mini" label-width="80px" >
                        <br>
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>二手车发布</strong></span>
                            </div>
                            <el-row>
                                <el-form-item label="单条发布收费：" prop="area_district" label-width="150px">
                                    <el-input type="number"  v-model.number="usedCarConfigForm.area_district" >
                                        <template slot="append">元/条</template>
                                    </el-input>

                                </el-form-item>

                                <el-form-item label="用户可免费发布：" prop="freeDays" label-width="150px">
                                    <el-input type="number" v-model.number="usedCarConfigForm.freeDays">
                                        <template slot="append">条/天</template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item label="" prop="authPhone" label-width="150px">
                                    <el-button @click="showAuthPhone" size="mini" type="warning" >审核机制设置
                                    </el-button>
                                </el-form-item>

                            </el-row>

                            <!--<el-row>
                                <el-form-item label="发布到本市收费：" prop="area_city" label-width="150px">
                                    <el-input type="number"   v-model.number="usedCarConfigForm.area_city">
                                        <template slot="append">元/条</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-form-item label="发布到本省收费：" prop="area_province"   label-width="150px">
                                    <el-input type="number"   v-model.number="usedCarConfigForm.area_province">
                                        <template slot="append">元/条</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>

                            <el-row>
                                <el-form-item label="发布到全国收费：" prop="area_country"  label-width="150px">
                                    <el-input type="number"  v-model.number="usedCarConfigForm.area_country">
                                        <template slot="append">元/条</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>-->

                        </el-card>

                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>二手车信息置顶</strong></span>
                            </div>
                            <el-row >
                                <el-form-item label="梯度一置顶：" prop="level1_days" label-width="150px">
                                    <el-input type="text" v-model.number="usedCarConfigForm.level1_days">
                                        <template slot="append">天</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收费" prop="top_level1">
                                    <el-input type="number" v-model.number="usedCarConfigForm.top_level1" >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>

                            <el-row>
                                <el-form-item label="梯度二置顶：" prop="level2_days" label-width="150px">
                                    <el-input type="text" v-model.number.number="usedCarConfigForm.level2_days">
                                        <template slot="append">天</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收费" prop="top_level2">
                                    <el-input type="number" v-model.number.number="usedCarConfigForm.top_level2" >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>

                            <el-row>
                                <el-form-item label="梯度三置顶：" prop="level3_days" label-width="150px">
                                    <el-input type="text" v-model.number="usedCarConfigForm.level3_days" >
                                        <template slot="append">天</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收费" prop="top_level3">
                                    <el-input type="number" v-model.number="usedCarConfigForm.top_level3">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-form-item label="梯度四置顶：" prop="level4_days" label-width="150px">
                                    <el-input type="text"  v-model.number="usedCarConfigForm.level4_days">
                                        <template slot="append">天</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收费" prop="top_level4">
                                    <el-input type="number" v-model.number="usedCarConfigForm.top_level4" >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-form-item label="梯度五置顶：" prop="level5_days" label-width="150px">
                                    <el-input type="text" v-model.number="usedCarConfigForm.level5_days" >
                                        <template slot="append">天</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收费" prop="top_level5">
                                    <el-input type="number" v-model.number="usedCarConfigForm.top_level5">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-row>

                        </el-card>
<!--                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>二手车发布</strong></span>
                            </div>
                            <el-row>
                                  <el-form-item label="发布到本区县收费：" prop="area_district" label-width="150px">
                                      <el-input type="number"  v-model.number="usedCarConfigForm.area_district" >
                                          <template slot="append">元/条</template>
                                      </el-input>

                                  </el-form-item>

                                  <el-form-item label="用户可免费发布：" prop="freeDays" label-width="150px">
                                      <el-input type="number" v-model.number="usedCarConfigForm.freeDays">
                                          <template slot="append">条/天</template>
                                      </el-input>
                                  </el-form-item>
                            </el-row>
                            <el-row>

                                  <el-form-item label="发布到本市收费：" prop="area_city" label-width="150px">
                                      <el-input type="number"   v-model.number="usedCarConfigForm.area_city">
                                          <template slot="append">元/条</template>
                                      </el-input>
                                  </el-form-item>
                          </el-row>
                            <el-row>
                              <el-form-item label="发布到本省收费：" prop="area_province"   label-width="150px">
                                  <el-input type="number"   v-model.number="usedCarConfigForm.area_province">
                                      <template slot="append">元/条</template>
                                  </el-input>
                              </el-form-item>
                          </el-row>

                          <el-row>
                              <el-form-item label="发布到全国收费：" prop="area_country"  label-width="150px">
                                  <el-input type="number"  v-model.number="usedCarConfigForm.area_country">
                                      <template slot="append">元/条</template>
                                  </el-input>
                              </el-form-item>
                          </el-row>

                        </el-card>
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>二手车信息置顶</strong></span>
                            </div>
                            <el-row >
                                        <el-form-item label="梯度一置顶：" prop="level1_days" label-width="150px">
                                            <el-input type="text" v-model.number="usedCarConfigForm.level1_days">
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="top_level1">
                                            <el-input type="number" v-model.number="usedCarConfigForm.top_level1" >
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                            </el-row>

                              <el-row>
                                  <el-form-item label="梯度二置顶：" prop="level2_days" label-width="150px">
                                      <el-input type="text" v-model.number.number="usedCarConfigForm.level2_days">
                                          <template slot="append">天</template>
                                      </el-input>
                                  </el-form-item>
                                  <el-form-item label="收费" prop="top_level2">
                                      <el-input type="number" v-model.number.number="usedCarConfigForm.top_level2" >
                                          <template slot="append">元</template>
                                      </el-input>
                                  </el-form-item>
                              </el-row>

                                <el-row>
                                    <el-form-item label="梯度三置顶：" prop="level3_days" label-width="150px">
                                        <el-input type="text" v-model.number="usedCarConfigForm.level3_days" >
                                            <template slot="append">天</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="收费" prop="top_level3">
                                        <el-input type="number" v-model.number="usedCarConfigForm.top_level3">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-row>
                                    <el-row>
                                        <el-form-item label="梯度四置顶：" prop="level4_days" label-width="150px">
                                            <el-input type="text"  v-model.number="usedCarConfigForm.level4_days">
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="top_level4">
                                            <el-input type="number" v-model.number="usedCarConfigForm.top_level4" >
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row>
                                        <el-form-item label="梯度五置顶：" prop="level5_days" label-width="150px">
                                            <el-input type="text" v-model.number="usedCarConfigForm.level5_days" >
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="top_level5">
                                            <el-input type="number" v-model.number="usedCarConfigForm.top_level5">
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>

                        </el-card>
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>第三方查询工具</strong></span>
                            </div>
                            <el-row>

                                        <el-form-item label="二手车估价收费：" prop="valuation" label-width="150px">
                                            <el-input type="number" v-model.number="usedCarConfigForm.valuation" >
                                                <template slot="append">元/次</template>
                                            </el-input>
                                        </el-form-item>

                                    </el-row>

                                    <el-row>
                                        <el-form-item label="碰撞查询收费：" prop="claims" label-width="150px">
                                            <el-input type="number"  v-model.number="usedCarConfigForm.claims" >
                                              <template slot="append">元/次</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>

                                    <el-row>
                                        <el-form-item label="维保查询收费：" prop="maintenance" label-width="150px">
                                            <el-input type="number"  v-model.number="usedCarConfigForm.maintenance" >
                                                <template slot="append">元/次</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>

                                    <el-row>
                                        <el-form-item label="违章查询收费：" prop="vihicleViolation" label-width="150px">
                                            <el-input type="number" v-model.number="usedCarConfigForm.vihicleViolation">
                                                <template slot="append">元/次</template>
                                            </el-input>

                                        </el-form-item>
                                    </el-row>

                        </el-card>-->

                        <el-card>
                            <div slot="header" class="clearfix">
                                <span><strong>用户发帖信息置顶</strong></span>
                            </div>
                            <el-row >
                                        <el-form-item label="梯度一置顶：" prop="q_level1_days" label-width="150px">
                                            <el-input type="text" v-model.number="usedCarConfigForm.q_level1_days">
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="q_top_level1">
                                            <el-input type="number" v-model.number="usedCarConfigForm.q_top_level1" >
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                            </el-row>

                              <el-row>
                                  <el-form-item label="梯度二置顶：" prop="q_level2_days" label-width="150px">
                                      <el-input type="text" v-model.number.number="usedCarConfigForm.q_level2_days">
                                          <template slot="append">天</template>
                                      </el-input>
                                  </el-form-item>
                                  <el-form-item label="收费" prop="q_top_level2">
                                      <el-input type="number" v-model.number.number="usedCarConfigForm.q_top_level2" >
                                          <template slot="append">元</template>
                                      </el-input>
                                  </el-form-item>
                              </el-row>

                                <el-row>
                                    <el-form-item label="梯度三置顶：" prop="q_level3_days" label-width="150px">
                                        <el-input type="text" v-model.number="usedCarConfigForm.q_level3_days" >
                                            <template slot="append">天</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="收费" prop="q_top_level3">
                                        <el-input type="number" v-model.number="usedCarConfigForm.q_top_level3">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-row>
                                    <el-row>
                                        <el-form-item label="梯度四置顶：" prop="q_level4_days" label-width="150px">
                                            <el-input type="text"  v-model.number="usedCarConfigForm.q_level4_days">
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="q_top_level4">
                                            <el-input type="number" v-model.number="usedCarConfigForm.q_top_level4" >
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row>
                                        <el-form-item label="梯度五置顶：" prop="q_level5_days" label-width="150px">
                                            <el-input type="text" v-model.number="usedCarConfigForm.q_level5_days" >
                                                <template slot="append">天</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="收费" prop="q_top_level5">
                                            <el-input type="number" v-model.number="usedCarConfigForm.q_top_level5">
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-row>

                            <el-row>

                                <el-form-item >
                                    <el-button type="primary"  size="medium" @click="validateFrom('privateUsedCarConfigForm',usedCarConfigForm.id?editData:addData)">{{usedCarConfigForm.id?"修改":"添加"}}</el-button>
                                </el-form-item>

                            </el-row>

                        </el-card>

                    </el-form>
                </el-row>
            <el-dialog :visible.sync="dialogAuthFormVisible" title="审核机制设置">

                <el-form :model="configForm" label-width="160px" ref="configForm" style="margin-left:20px;">
                    <h3>二手车人工审核</h3>
                    <el-radio-group @change="updateUsedCarAuthSwitch()" v-model="configForm.usedCarAuthSwitch">
                        <el-radio :label="1">都不审核</el-radio>
                        <el-radio :label="2">仅免费发布审核</el-radio>
                        <el-radio :label="3">全部审核</el-radio>
                    </el-radio-group>

                </el-form>
                <h3 style="margin-left:20px;">二手车发布白名单</h3>
                <div style="margin-left:20px;">以下白名单用户，发布二手车信息不需要审核</div>
                <div style="margin-left:20px;margin-top:10px">
                    <el-button @click="openAuthFormDialog()" size="medium" type="primary">添加白名单</el-button>
                </div>
                <div>
                    <el-table :data="whitePhoneData">
                        <el-table-column label="手机号" property="phone" width="150"></el-table-column>
                        <el-table-column label="限每日免费发布(条)" property="count" width="200"></el-table-column>
                        <el-table-column label="时间" property="createTime" width="200"></el-table-column>
                        <el-table-column label="操作">
                            <template  slot-scope="scope">
                                <el-button @click="updatePrivateUsedCarWhite(scope.row)" type="text">修改</el-button>
                                <el-button @click="deletePrivateUsedCarWhite(scope.row.id)" type="text">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination :current-page.sync="currentPage" :page-size="pageSize" :total="total"
                                   class="basic-margin" layout="total, prev, pager, next">
                    </el-pagination>
                </div>

            </el-dialog>

            <el-dialog :visible.sync="dialogWhitePhoneFormVisible" title="白名单">
                <el-form :model="whitePhoneForm">

                    <el-form-item label="用户账号" label-width="120px">
                        <el-input :readonly="whitePhoneForm.isUpdate" placeholder="请输入用户11位手机账号"
                                  v-model="whitePhoneForm.phone"></el-input>
                    </el-form-item>

                    <el-form-item label="限每日免费发布" label-width="120px">
                        <el-input placeholder="限每日免费发布(条)" v-model="whitePhoneForm.count"></el-input>
                    </el-form-item>

                </el-form>
                <div class="dialog-footer" slot="footer">
                    <el-button @click="dialogWhitePhoneFormVisible = false">取 消</el-button>
                    <el-button @click="saveWhitePhone" type="primary">确 定</el-button>
                </div>
            </el-dialog>
        </el-card>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import usedCarModel from '../../framework/models/usedCarModel'

export default {
  extends: BasicPager,
  name: 'privateUsedCarConfig',
  data: function () {
    // //发布定价规则验证
    var checkRelease = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{1})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留一位哦！'))
      }

      let field = rule.field
      let isCheckValue = false
      let priceIsError = false
      let errorText = null
      switch (field) {
        case 'area_district':// 本县
          priceIsError = value >= this.usedCarConfigForm.area_city
          errorText = '本县价格必须小于本市价格'
          break
        case 'area_city':// 本市
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.area_province
          errorText = '本市价格必须小于本省价格'
          this.$refs['privateUsedCarConfigForm'].validateField('area_district')
          break
        case 'area_province':// 本省
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.area_country
          errorText = '本省价格必须小于全国价格'
          this.$refs['privateUsedCarConfigForm'].validateField('area_city')
          break
        case 'area_country':// 全国
          isCheckValue = true
          this.$refs['privateUsedCarConfigForm'].validateField('area_province')
          break
        default:
      }

      // 验证价格不能为 0
      if (isCheckValue && value === 0) {
        return callback(new Error('价格不能为 0 元'))
      }

      // 判断价格是否有问题
      if (priceIsError) {
        return callback(new Error(errorText))
      }
      callback()
    }

    // 二手车信息置顶梯度规则
    var checkLevel = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{1})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留一位哦！'))
      }

      let field = rule.field
      let isCheckValue = false
      let priceIsError = false
      let errorText = null
      switch (field) {
        case 'top_level1':// 梯度1
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.top_level2
          errorText = '梯度一价格必须小于梯度二价格'
          break
        case 'top_level2':// 梯度2
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.top_level3
          errorText = '梯度二价格必须小于梯度三价格'
          this.$refs['privateUsedCarConfigForm'].validateField('top_level1')
          break
        case 'top_level3':// 梯度3
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.top_level4
          errorText = '梯度三价格必须小于梯度四价格'
          this.$refs['privateUsedCarConfigForm'].validateField('top_level2')
          break
        case 'top_level4':// 梯度5
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.top_level5
          errorText = '梯度四价格必须小于梯度五价格'
          this.$refs['privateUsedCarConfigForm'].validateField('top_level3')
          break
        case 'top_level5':// 梯度6
          isCheckValue = true
          this.$refs['privateUsedCarConfigForm'].validateField('top_level4')
          break
        default:
      }

      // 验证价格不能为 0
      if (isCheckValue && value === 0) {
        return callback(new Error('价格不能为 0 元'))
      }

      // 判断价格是否有问题
      if (priceIsError) {
        return callback(new Error(errorText))
      }
      callback()
    }

    // 用户发帖信息置顶梯度规则
    var checkLeve2 = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{1})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留一位哦！'))
      }

      let field = rule.field
      let isCheckValue = false
      let priceIsError = false
      let errorText = null
      switch (field) {
        case 'q_top_level1':// 梯度1
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.q_top_level2
          errorText = '梯度一价格必须小于梯度二价格'
          break
        case 'q_top_level2':// 梯度2
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.q_top_level3
          errorText = '梯度二价格必须小于梯度三价格'
          this.$refs['privateUsedCarConfigForm'].validateField('q_top_level1')
          break
        case 'q_top_level3':// 梯度3
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.q_top_level4
          errorText = '梯度三价格必须小于梯度四价格'
          this.$refs['privateUsedCarConfigForm'].validateField('q_top_level2')
          break
        case 'q_top_level4':// 梯度5
          isCheckValue = true
          priceIsError = value >= this.usedCarConfigForm.q_top_level5
          errorText = '梯度四价格必须小于梯度五价格'
          this.$refs['privateUsedCarConfigForm'].validateField('q_top_level3')
          break
        case 'q_top_level5':// 梯度6
          isCheckValue = true
          this.$refs['privateUsedCarConfigForm'].validateField('q_top_level4')
          break
        default:
      }

      // 验证价格不能为 0
      if (isCheckValue && value === 0) {
        return callback(new Error('价格不能为 0 元'))
      }

      // 判断价格是否有问题
      if (priceIsError) {
        return callback(new Error(errorText))
      }
      callback()
    }

    // 工具估价
    var checkTool = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{0,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }

      let field = rule.field
      switch (field) {
        case 'valuation':
          if (value < 0.02) {
            return callback(new Error('估价价格不能小于成本价0.02元'))
          }
          break
        case 'violation':
          if (value < 26) {
            return callback(new Error('出险查询不能小于成本价26元'))
          }
          break
        case 'vihicleViolation':
          if (value < 0.16) {
            return callback(new Error('违章查询不能小于成本价0.16元'))
          }
          break
        case 'maintenance':
          if (value < 5) {
            return callback(new Error('维保查询不能小于成本价5元'))
          }
          break
        case 'claims':
          if (value < 18) {
            return callback(new Error('碰撞查询不能小于成本价18元'))
          }
          break
        default:
      }
      callback()
    }

    return {
      dialogAuthFormVisible: false,
      dialogWhitePhoneFormVisible: false,
      isShow: true,
      options: [],
      whitePhoneData: [],
      selectedUsedCarConfigId: null,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      openAuthFormDialog: function () {
        this.dialogWhitePhoneFormVisible = true
        this.whitePhoneForm.isUpdate = false
        this.whitePhoneForm.whitePhoneListId = null
        this.whitePhoneForm.count = null
        this.whitePhoneForm.phone = null
      },
      configForm: {
        usedCarAuthSwitch: 3
      },
      whitePhoneForm: {
        phone: null,
        count: null,
        isUpdate: false,
        whitePhoneListId: null
      },
      usedCarConfigForm: {
        channelId: null,
        id: null,
        freeDays: null,
        area_country: null,
        area_province: null,
        area_city: null,
        area_district: null,
        top_level1: null,
        level1_days: null,
        top_level2: null,
        level2_days: null,
        top_level3: null,
        level3_days: null,
        top_level4: null,
        level4_days: null,
        top_level5: null,
        level5_days: null,

        q_top_level1: null,
        q_level1_days: null,
        q_top_level2: null,
        q_level2_days: null,
        q_top_level3: null,
        q_level3_days: null,
        q_top_level4: null,
        q_level4_days: null,
        q_top_level5: null,
        q_level5_days: null,

        valuation: null,
        violation: null,
        vihicleViolation: null,
        claims: null,
        maintenance: null
      },
      rules: {
        freeDays: [
          { required: true, message: '不能为空', trigger: 'blur' }

        ],
        area_district: [
          { required: true, message: '本县不能为空', trigger: 'blur' }
        ],
        area_city: [
          { required: true, message: '本市不能为空', trigger: 'blur' }
        ],
        area_province: [
          { required: true, message: '本省不能为空', trigger: 'blur' }
        ],
        area_country: [
          { required: true, message: '全部价格不能为空', trigger: 'blur' }
        ],
        top_level1: [
          { required: true, message: '梯度一不能为空', trigger: 'blur' },
          { validator: checkLevel, trigger: 'blur' }
        ],
        top_level2: [
          { required: true, message: '梯度二不能为空', trigger: 'blur' },
          { validator: checkLevel, trigger: 'blur' }
        ],
        top_level3: [
          { required: true, message: '梯度三不能为空', trigger: 'blur' },
          { validator: checkLevel, trigger: 'blur' }
        ],
        top_level4: [
          { required: true, message: '梯度四不能为空', trigger: 'blur' },
          { validator: checkLevel, trigger: 'blur' }
        ],
        top_level5: [
          { required: true, message: '梯度五不能为空', trigger: 'blur' },
          { validator: checkLevel, trigger: 'blur' }
        ],

        q_top_level1: [
          { required: true, message: '梯度一不能为空', trigger: 'blur' },
          { validator: checkLeve2, trigger: 'blur' }
        ],
        q_top_level2: [
          { required: true, message: '梯度二不能为空', trigger: 'blur' },
          { validator: checkLeve2, trigger: 'blur' }
        ],
        q_top_level3: [
          { required: true, message: '梯度三不能为空', trigger: 'blur' },
          { validator: checkLeve2, trigger: 'blur' }
        ],
        q_top_level4: [
          { required: true, message: '梯度四不能为空', trigger: 'blur' },
          { validator: checkLeve2, trigger: 'blur' }
        ],
        q_top_level5: [
          { required: true, message: '梯度五不能为空', trigger: 'blur' },
          { validator: checkLeve2, trigger: 'blur' }
        ],

        valuation: [
          { required: true, message: '车辆估价不能为空', trigger: 'blur' },
          { validator: checkTool, trigger: 'blur' }
        ],
        violation: [
          { required: true, message: '出险查询不能为空', trigger: 'blur' },
          { validator: checkTool, trigger: 'blur' }
        ],
        vihicleViolation: [
          { required: true, message: '违章查询不能为空', trigger: 'blur' },
          { validator: checkTool, trigger: 'blur' }
        ],
        maintenance: [
          { required: true, message: '维保查询不能为空', trigger: 'blur' },
          { validator: checkTool, trigger: 'blur' }
        ],
        claims: [
          { required: true, message: '碰撞查询不能为空', trigger: 'blur' },
          { validator: checkTool, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let loginPath = this.getLoginInfo().loginPath

    if (loginPath === 'channel') {
      this.isShow = false
    }
    this.loadAuthPhoneList()
  },
  mounted () {
    let that = this
    that.loadUsedCarConfigSourceData()
  },
  watch: {
    selectedUsedCarConfigId: function (newValue) {
      this.selectData(newValue)
    }
  },
  methods: {
    saveWhitePhone: function () {
      let _this = this
      let phone = this.whitePhoneForm.phone
      if (!phone) {
        _this.$message({
          message: '手机号不能为空！',
          type: 'error'
        })
        return
      }
      if (phone.length > 15) {
        _this.$message({
          message: '手机号最多15位！',
          type: 'error'
        })
        return
      }

      let count = this.whitePhoneForm.count + ''
      if (!count) {
        _this.$message({
          message: '免费次数不能为空！',
          type: 'error'
        })
        return
      } else {
        var r = new RegExp('^[0-9]*$')
        if (!r.test(this.whitePhoneForm.count)) {
          _this.$message({
            message: '请输入数字！',
            type: 'error'
          })
          return
        }
      }

      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else {
        id = this.usedCarConfigForm.channelId
      }

      let param = { id: id, phone: phone, count: count, whitePhoneListId: this.whitePhoneForm.whitePhoneListId }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '添加成功！',
              type: 'success'
            })
            _this.dialogWhitePhoneFormVisible = false
            _this.loadAuthPhoneList()
          } else {
            _this.$message({
              message: dataInfo.errMsg,
              type: 'error'
            })
          }
        }
      }
      usedCarModel.saveOrUpdateWhitePhone(_this, param, listener)
    },
    deletePrivateUsedCarWhite: function (id) {
      this.$confirm('确定删除白名单', '白名单！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let param = { 'id': id }
        let listener = {
          success: function (dataInfo) {
            if (dataInfo.success) {
              _this.$message({
                message: '刪除成功！',
                type: 'success'
              })
              _this.loadAuthPhoneList()
            } else {
              _this.$message({
                message: '刪除失败！',
                type: 'error'
              })
            }
          }
        }
        usedCarModel.deletePrivateUsedCarWhite(_this, param, listener)
      }).catch(() => {

      })
    },
    updatePrivateUsedCarWhite: function (data) {
      this.dialogWhitePhoneFormVisible = true
      this.whitePhoneForm.isUpdate = true
      this.whitePhoneForm.whitePhoneListId = data.id
      this.whitePhoneForm.count = data.count
      this.whitePhoneForm.phone = data.phone
    },
    updateUsedCarAuthSwitch: function () {
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else {
        id = this.usedCarConfigForm.channelId
      }
      let _this = this
      let param = { 'id': id, 'usedCarAuthSwitch': this.configForm.usedCarAuthSwitch }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
        }
      }
      usedCarModel.changeChannelConfigAuthSwitch(_this, param, listener)
    },
    loadAuthPhoneList: function () {
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else {
        id = this.usedCarConfigForm.channelId
      }
      let _this = this
      let param = {
        id: id,
        pageNum: _this.currentPage

      }
      let listener = {
        success: function (dataInfo) {
          _this.whitePhoneData = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }
      usedCarModel.findPrivateUsedCarWhiteList(_this, param, listener)
    },
    showAuthPhone: function () {
      this.dialogAuthFormVisible = true
      let _this = this
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else {
        id = this.usedCarConfigForm.channelId
      }

      let param = { 'id': id }
      let listener = {
        success: function (dataInfo) {
          _this.configForm.usedCarAuthSwitch = dataInfo.datas.usedCarAuthSwitch
        }
      }
      usedCarModel.getChannelConfig(_this, param, listener)
      this.loadAuthPhoneList()
    },
    loadUsedCarConfigSourceData: function () {
      let that = this
      let loginPath = that.getLoginInfo().loginPath
      let params = { channelId: loginPath === 'channel' ? that.getLoginInfo().id : null }
      let listener = {
        success: function (dataInfo) {
          that.options = dataInfo.datas
          if (dataInfo.datas) {
            that.selectedUsedCarConfigId = dataInfo.datas[0].usedCarConfigId
            that.usedCarConfigForm.channelId = dataInfo.datas[0].channelId
          }
        }
      }
      usedCarModel.findUsedCarConfigPriceList(that, params, listener)
    },
    selectData: function (id) {
      let that = this
      that.usedCarConfigForm.id = id
      let params = { id: id }
      let listener = {
        success: function (dataInfo) {
          let data = dataInfo.datas
          if (dataInfo.success) {
            that.usedCarConfigForm.channelId = data.channelId
            let area = JSON.parse(data.areaPrice)
            let topPrice = JSON.parse(data.topPrice)

            let questionTopPrice = JSON.parse(data.questionTopPrice)

            let toolsPrice = JSON.parse(data.outToolsPrice)
            for (let i = 0; i < area.length; i++) {
              let item = area[i]
              switch (item.area_name) {
                case 'area_country':that.usedCarConfigForm.area_country = item.price / 100; break
                case 'area_province':that.usedCarConfigForm.area_province = item.price / 100; break
                case 'area_city':that.usedCarConfigForm.area_city = item.price / 100; break
                case 'area_district':that.usedCarConfigForm.area_district = item.price / 100; that.usedCarConfigForm.freeDays = item.freeDays; break
                default :break
              }
            }
            for (let i = 0; i < topPrice.length; i++) {
              let item = topPrice[i]
              switch (item.level) {
                case 'level1':that.usedCarConfigForm.top_level1 = item.price / 100; that.usedCarConfigForm.level1_days = item.days; break
                case 'level2':that.usedCarConfigForm.top_level2 = item.price / 100; that.usedCarConfigForm.level2_days = item.days; break
                case 'level3':that.usedCarConfigForm.top_level3 = item.price / 100; that.usedCarConfigForm.level3_days = item.days; break
                case 'level4':that.usedCarConfigForm.top_level4 = item.price / 100; that.usedCarConfigForm.level4_days = item.days; break
                case 'level5':that.usedCarConfigForm.top_level5 = item.price / 100; that.usedCarConfigForm.level5_days = item.days; break
              }
            }

            for (let i = 0; i < questionTopPrice.length; i++) {
              let item = questionTopPrice[i]
              switch (item.level) {
                case 'level1':that.usedCarConfigForm.q_top_level1 = item.price / 100; that.usedCarConfigForm.q_level1_days = item.days; break
                case 'level2':that.usedCarConfigForm.q_top_level2 = item.price / 100; that.usedCarConfigForm.q_level2_days = item.days; break
                case 'level3':that.usedCarConfigForm.q_top_level3 = item.price / 100; that.usedCarConfigForm.q_level3_days = item.days; break
                case 'level4':that.usedCarConfigForm.q_top_level4 = item.price / 100; that.usedCarConfigForm.q_level4_days = item.days; break
                case 'level5':that.usedCarConfigForm.q_top_level5 = item.price / 100; that.usedCarConfigForm.q_level5_days = item.days; break
              }
            }

            for (let i = 0; i < toolsPrice.length; i++) {
              let item = toolsPrice[i]
              switch (item.tools) {
                case 'valuation':that.usedCarConfigForm.valuation = item.price / 100; break
                case 'violation':that.usedCarConfigForm.violation = item.price / 100; break
                case 'vihicleViolation':that.usedCarConfigForm.vihicleViolation = item.price / 100; break
                case 'claims':that.usedCarConfigForm.claims = item.price / 100; break
                case 'maintenance':that.usedCarConfigForm.maintenance = item.price / 100; break
              }
            }
          }
        }
      }
      usedCarModel.getPrivateUsedCarConfigById(that, params, listener)
    },
    addData: function () {
      let that = this
      let params = {}
      let areaPrice = [{ 'area_name': 'area_country', 'price': that.usedCarConfigForm.area_country * 100 }, { 'area_name': 'area_province', 'price': that.usedCarConfigForm.area_province * 100 }, { 'area_name': 'area_city', 'price': that.usedCarConfigForm.area_city * 100 }, { 'area_name': 'area_district', 'price': that.usedCarConfigForm.area_district * 100, 'freeDays': that.usedCarConfigForm.freeDays }]
      let topPrice = [{ 'level': 'level1', 'price': that.usedCarConfigForm.top_level1 * 100, 'days': that.usedCarConfigForm.level1_days }, { 'level': 'level2', 'price': that.usedCarConfigForm.top_level2 * 100, 'days': that.usedCarConfigForm.level2_days }, { 'level': 'level3', 'price': that.usedCarConfigForm.top_level3 * 100, 'days': that.usedCarConfigForm.level3_days }, { 'level': 'level4', 'price': that.usedCarConfigForm.top_level4 * 100, 'days': that.usedCarConfigForm.level4_days }, { 'level': 'level5', 'price': that.usedCarConfigForm.top_level5 * 100, 'days': that.usedCarConfigForm.level5_days }]
      let outToolsPrice = [{ 'tools': 'valuation', 'price': that.usedCarConfigForm.valuation * 100 }, { 'tools': 'violation', 'price': that.usedCarConfigForm.violation * 100 }, { 'tools': 'vihicleViolation', 'price': that.usedCarConfigForm.vihicleViolation * 100 }, { 'tools': 'callPhone', 'price': 100 }, { 'tools': 'travellingExpenses', 'price': 100 }, { 'tools': 'assurance', 'price': 100 }, { 'tools': 'maintenance', 'price': that.usedCarConfigForm.maintenance * 100 }, { 'tools': 'claims', 'price': that.usedCarConfigForm.claims * 100 }]

      let questionTopPrice = [{ 'level': 'level1', 'price': that.usedCarConfigForm.q_top_level1 * 100, 'days': that.usedCarConfigForm.q_level1_days }, { 'level': 'level2', 'price': that.usedCarConfigForm.q_top_level2 * 100, 'days': that.usedCarConfigForm.q_level2_days }, { 'level': 'level3', 'price': that.usedCarConfigForm.q_top_level3 * 100, 'days': that.usedCarConfigForm.q_level3_days }, { 'level': 'level4', 'price': that.usedCarConfigForm.q_top_level4 * 100, 'days': that.usedCarConfigForm.q_level4_days }, { 'level': 'level5', 'price': that.usedCarConfigForm.q_top_level5 * 100, 'days': that.usedCarConfigForm.q_level5_days }]

      params = { areaPrice: JSON.stringify(areaPrice), topPrice: JSON.stringify(topPrice), questionTopPrice: JSON.stringify(questionTopPrice), outToolsPrice: JSON.stringify(outToolsPrice) }
      let listener = {
        success: function (dataInfo) {
          that.$message({
            message: '修改成功',
            type: 'success'
          })
        }
      }
      usedCarModel.savePrivateUsedCarConfig(that, params, listener)
    },
    editData: function () {
      let that = this
      let params = {}
      let areaPrice = [{ 'area_name': 'area_country', 'price': that.usedCarConfigForm.area_country * 100 }, { 'area_name': 'area_province', 'price': that.usedCarConfigForm.area_province * 100 }, { 'area_name': 'area_city', 'price': that.usedCarConfigForm.area_city * 100 }, { 'area_name': 'area_district', 'price': that.usedCarConfigForm.area_district * 100, 'freeDays': that.usedCarConfigForm.freeDays }]
      let topPrice = [{ 'level': 'level1', 'price': that.usedCarConfigForm.top_level1 * 100, 'days': that.usedCarConfigForm.level1_days }, { 'level': 'level2', 'price': that.usedCarConfigForm.top_level2 * 100, 'days': that.usedCarConfigForm.level2_days }, { 'level': 'level3', 'price': that.usedCarConfigForm.top_level3 * 100, 'days': that.usedCarConfigForm.level3_days }, { 'level': 'level4', 'price': that.usedCarConfigForm.top_level4 * 100, 'days': that.usedCarConfigForm.level4_days }, { 'level': 'level5', 'price': that.usedCarConfigForm.top_level5 * 100, 'days': that.usedCarConfigForm.level5_days }]
      let outToolsPrice = [{ 'tools': 'valuation', 'price': that.usedCarConfigForm.valuation * 100 }, { 'tools': 'violation', 'price': that.usedCarConfigForm.violation * 100 }, { 'tools': 'vihicleViolation', 'price': that.usedCarConfigForm.vihicleViolation * 100 }, { 'tools': 'callPhone', 'price': 100 }, { 'tools': 'travellingExpenses', 'price': 100 }, { 'tools': 'assurance', 'price': 100 }, { 'tools': 'maintenance', 'price': that.usedCarConfigForm.maintenance * 100 }, { 'tools': 'claims', 'price': that.usedCarConfigForm.claims * 100 }]
      let questionTopPrice = [{ 'level': 'level1', 'price': that.usedCarConfigForm.q_top_level1 * 100, 'days': that.usedCarConfigForm.q_level1_days }, { 'level': 'level2', 'price': that.usedCarConfigForm.q_top_level2 * 100, 'days': that.usedCarConfigForm.q_level2_days }, { 'level': 'level3', 'price': that.usedCarConfigForm.q_top_level3 * 100, 'days': that.usedCarConfigForm.q_level3_days }, { 'level': 'level4', 'price': that.usedCarConfigForm.q_top_level4 * 100, 'days': that.usedCarConfigForm.q_level4_days }, { 'level': 'level5', 'price': that.usedCarConfigForm.q_top_level5 * 100, 'days': that.usedCarConfigForm.q_level5_days }]

      params = { areaPrice: JSON.stringify(areaPrice), topPrice: JSON.stringify(topPrice), questionTopPrice: JSON.stringify(questionTopPrice), outToolsPrice: JSON.stringify(outToolsPrice), id: that.usedCarConfigForm.id }
      let listener = {
        success: function (dataInfo) {
          that.$message({
            message: '修改成功',
            type: 'success'
          })
        }
      }
      usedCarModel.editPrivateUsedCarConfig(that, params, listener)
    }
  }
}
</script>

<style scoped>

</style>
